var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M13.3126 10.7714L19.1379 4H17.7575L12.6994 9.87954L8.65953 4H4L10.1091 12.8909L4 19.9918H5.38049L10.722 13.7828L14.9884 19.9918H19.6479L13.3123 10.7714H13.3126ZM11.4219 12.9692L10.8029 12.0839L5.87789 5.03921H7.99824L11.9728 10.7245L12.5918 11.6098L17.7582 18.9998H15.6378L11.4219 12.9696V12.9692Z","fill":"black"}));
}

Twitter.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Twitter;

Twitter.default = Twitter;
